module.exports = __webpack_public_path__ + "img/image15.692d54ef.png";